import React, { useEffect, useState } from "react";
import { callPostApi } from "../../api/ApiCaller";
import { SET_GAME_BONUS_RESULT_POST } from "../../api/ApiConst";
import { getFormattedAmountWithDenomination } from "../../utils/TextUtils";
import $ from "jquery";

let interactionDisabled = false;

function PumpkinBonus({ gameSessionRecordId, onBonusRoundCompleted, walletBalance, denomination }) {
    const [imageValue, setImageValue] = useState(0);
    const [premioAmount, setPremioAmount] = useState(0);
    const [bonusAmount, setBonusAmount] = useState(0);
    const [totalGameWin, setTotalGameWin] = useState(0);
    const [isAnimatingPremioValue, setISAnimatingPremioValue] = useState(false);
    const [isAnimatingBonusValue, setIsAnimatingBonusValue] = useState(false);
    const [defaultRecords, setDefaultRecords] = useState(new Array(12).fill({ pumpkinBonus: 0, tileNumber: 0 }));
    const rows = [
        [0, 1, 2, 3],
        [4, 5, 6, 7],
        [8, 9, 10, 11],
    ];
    useEffect(() => {
        playSoundByIdInLoop('witchPumpkin-bonus')
        handleBoxClick();
    }, []);

    const playSoundByIdInLoop = (soundTagId) => {
        let sound = $("#" + soundTagId)[0];
        if (sound) {
            sound.currentTime = 0;
            sound.play();
            sound.loop = true;
        }
    };

    const pauseSoundById = (soundTagId) => {
        let sound = $("#" + soundTagId)[0];
        if (sound) {
            sound.pause();
            sound.currentTime = 0;
        }
    };

    const handleBoxClick = () => {
        if (interactionDisabled) return;
        interactionDisabled = true;

        const payload = {
            bonusType: "Bonus05LittleWitchPumpkinPulling",
            recordId: gameSessionRecordId,
        };

        callPostApi(SET_GAME_BONUS_RESULT_POST, payload, {}, (response) => {
            const res = response?.responsePacket;

            const bonusAllWinning = res?.bonusDetailList;
            let totalPumpkinAmount = res?.totalBonusWinnings;
            let totalWinnAmount = res?.totalWinnings;

            setTotalGameWin(totalWinnAmount)
            const updatedRecords = bonusAllWinning.map((item) => ({
                pumpkinBonus: item.bonus,
                tileNumber: item.tileNumber,
            }));
            showImageLoop(updatedRecords, totalPumpkinAmount, totalWinnAmount);
            setDefaultRecords(updatedRecords);

            if (response?.errorCode !== 0) {
                console.error("API Call Failed:", response?.errorMessage || "Unknown error");
            }
        });
    };

    // const incrementPremioAmount = (newBonus) => {
    //     console.log(newBonus,'bonusbonus');
    //     if (newBonus > 0) {
    //         setPremioAmount((prevAmount) => prevAmount + newBonus);
    //     }
    // };

    const animatePremioValue = (totalGameWinning) => {
        if (isAnimatingPremioValue) return;
        setISAnimatingPremioValue(true);

        let currentValue = totalGameWinning;
        const steps = 100;
        const stepSize = totalGameWinning / steps;
        const animationSpeed = 10;

        const intervalId = setInterval(() => {
            currentValue -= stepSize;
            setPremioAmount(Math.round(currentValue));

            if (currentValue <= 0 || Math.abs(currentValue) < Math.abs(stepSize)) {
                clearInterval(intervalId);
                setPremioAmount(0);
                // setPremioAmount(totalGameWinning);
                setISAnimatingPremioValue(false);
            }
        }, animationSpeed);
    };

    const animateBonusValue = (totalBonusWinning, totalWinnAmount) => {
        if (isAnimatingBonusValue) return;
        setIsAnimatingBonusValue(true);

        let currentValue = 0;
        const steps = 100;
        const stepSize = totalBonusWinning / steps;
        const animationSpeed = 10;

        const intervalId = setInterval(() => {
            currentValue += stepSize;
            setBonusAmount(Math.round(currentValue));

            if (currentValue >= totalBonusWinning || Math.abs(totalBonusWinning - currentValue) < Math.abs(stepSize)) {
                clearInterval(intervalId);
                setBonusAmount(totalBonusWinning);
                setIsAnimatingBonusValue(false);
                setTimeout(() => {
                    pauseSoundById('witchPumpkin-bonus');
                    onBonusRoundCompleted(totalWinnAmount);
                    interactionDisabled = false;
                    setISAnimatingPremioValue(false);
                }, 4000);
            }
        }, animationSpeed);
    };

    const delay = () => {
        return new Promise((resolve) => setTimeout(resolve, 3000));
    };

    const showImageLoop = async (updatedRecords, totalBonuswin, totalWinnAmount) => {
        for (let row of rows) {
            for (let i = 0; i < row.length; i++) {
                const tileIndex = row[i];
                setImageValue(tileIndex);
                await delay();

                const tileBonus = updatedRecords[tileIndex]?.pumpkinBonus;

                if (tileBonus > 0) {
                    setPremioAmount((prevAmount) => prevAmount + tileBonus);
                }
            }
        }

        setTimeout(() => {
            animatePremioValue(totalBonuswin);
            animateBonusValue(totalBonuswin, totalWinnAmount);
        }, 1000);
    };


    const loadStaticAudio = () => (
        <div style={{ display: "none" }}>
            <audio controls id="witchPumpkin-bonus" className="audioFile">
                <source src="assets/bonus-bruxa.ogg" type="audio/mpeg" />
            </audio>
        </div>
    );


    return (
        <>
        <div className="h-100 w-100 position-relative">
            <img className="h-100 w-100" src="assets/img/pumpkin/bg.png" alt="" />
            <div className="contentPosition">
                <div className="header">
                    <div className="row align-content-center">
                        <div className="col-4">
                            <div className="d-flex align-content-center gap-2">
                                <div className="btn-heading text-green">CREDITO</div>
                                <div className="header-custom-btn">{getFormattedAmountWithDenomination(walletBalance, denomination)}</div>
                            </div>
                        </div>
                        <div className="col-4">
                            <div className="d-flex align-content-center gap-2 justify-content-center">
                                <div className="btn-heading text-green">PREMIO</div>
                                <div className="header-custom-btn">{bonusAmount}</div>
                            </div>
                        </div>
                        <div className="col-4">
                            <div className="d-flex align-content-center gap-2 justify-content-end">
                                <div className="btn-heading text-green">BONUS</div>
                                <div className="header-custom-btn">{premioAmount}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="pumpkin-bonus-block">
                    <div className="pumpkin-bonus-block-row h-100">
                        <div className="pumpkin-board-row">
                            <div className="pumpkin-boardContent row">
                                {rows.map((row, rowIndex) => (
                                    row.map((value) => {
                                        return (
                                            <div className="col-3" style={{ height: "33.33%" }}>
                                                <div key={value} className="pumpkin-boardContentBox">
                                                    {imageValue >= value ? (

                                                        <div className="position-absolute top-0 end-0 bottom-0 start-0">
                                                            {defaultRecords[value]?.pumpkinBonus > 0 ? (
                                                                <img
                                                                    id={`animPumpkin-${value}`}
                                                                    className="dice-image"
                                                                    src={`assets/img/pumpkin/anim-pumpkin.gif?v=${gameSessionRecordId + "-" + value}`}
                                                                    alt="Pumpkin Animation"
                                                                />
                                                            ) : (
                                                                <img
                                                                    id={`animWitch-${value}`}
                                                                    className="dice-image"
                                                                    src={`assets/img/pumpkin/anim-witch.gif?v=${gameSessionRecordId + "-" + value}`}
                                                                    alt="Witch Animation"
                                                                />
                                                            )}
                                                        </div>
                                                    ) : (
                                                        <img className="dice-image" src="assets/img/pumpkin/box-bg.png" />
                                                    )}
                                                </div>
                                            </div>
                                        );
                                    })


                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        {loadStaticAudio()}
        </>
    );
}

export default PumpkinBonus;
